import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { add } from 'date-fns';
import { BDD_INFO_URL } from 'applications/disability-benefits/all-claims/constants';

import { formatDate } from '../../../shared/utils/dates';
import { getDiffInDays } from '../utils';
import { usePathHistory } from '../utils/tracking/PathHistoryContext';
import pageNames from './pageNames';
import SubTaskContainerHeader from '../SubTaskContainerHeader';
import {
  trackSubtaskStepView,
  trackUnableToFileBddDisplayed,
  trackExternalLinkClick,
} from '../../utils/tracking/features/subtaskTracking';

const UnableToFileBDDPage = ({ data = {} }) => {
  const { addStep, getHistory } = usePathHistory();
  const { radDate } = data;

  const differenceBetweenDatesInDays = getDiffInDays(radDate) - 179;
  const daysText = differenceBetweenDatesInDays === 1 ? 'day' : 'days';
  const today = new Date();
  const dateEligible = formatDate(
    add(today, { days: differenceBetweenDatesInDays }),
  );

  useEffect(() => {
    trackSubtaskStepView({
      stepName: pageNames.unableToFileBDD,
      pathHistoryContext: { addStep, getHistory },
    });
    trackUnableToFileBddDisplayed({
      reason: 'too-early',
      daysRemaining: getDiffInDays(radDate),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <SubTaskContainerHeader title="File your disability claim later" />
      <div id={pageNames.unableToFileBDD}>
        <va-alert status="info">
          <h3 slot="headline">
            You can’t file your pre-discharge claim right now
          </h3>
          <p className="vads-u-margin-top--0">
            Based on your separation date, you’ll be eligible to file a Benefits
            Delivery at Discharge (BDD) claim (also known as a “pre-discharge
            claim”) using VA Form 21-526EZ in{' '}
            <strong>{differenceBetweenDatesInDays}</strong> {daysText} (
            <strong>{dateEligible}</strong>).
          </p>
          <p>
            <va-link
              external
              href={BDD_INFO_URL}
              text="Learn more about the pre-discharge claim"
              onClick={() => {
                trackExternalLinkClick({
                  linkLabel: 'Learn more about the pre-discharge claim',
                  pageName: pageNames.unableToFileBDD,
                  pathHistoryData: getHistory(),
                });
              }}
            />
          </p>
        </va-alert>
        <p>
          You can file a pre-discharge claim online through the Benefits
          Delivery at Discharge (BDD) program if you’re separating from the
          military in the next 180 to 90 days.
        </p>
      </div>
    </>
  );
};

UnableToFileBDDPage.propTypes = {
  data: PropTypes.shape({}),
};

export default {
  name: pageNames.unableToFileBDD,
  component: UnableToFileBDDPage,
  back: pageNames.rad,
  next: null,
};
